import axios from 'axios';

const axiosConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'api-key': process.env.REACT_APP_SECRET_KEY,
  },
};

const instance = axios.create(axiosConfig);

export { instance as axios };
